import { makeStyles, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { colors } from "../constants/colors";
import { commonStrings } from "./StringBundle";

const useStyles = makeStyles((theme) => ({
  paginationContainer: {
    display: "flex",
    justifyContent: "flex-end",  
    marginTop: theme.spacing(2),
  },
  pagination: {
    "& .MuiPaginationItem-root": {
      border: "1px solid #ccc",  
      borderRadius: "unset",
      margin: "0 2px",
    },
    "& .Mui-selected": {
      backgroundColor: "transparent", 
      color: colors.orange,
      borderColor: colors.orange,
    },
    "& .MuiPaginationItem-root:hover": {
      backgroundColor: "transparent",
      color: colors.link,
      borderColor: colors.link,
    },
    "& .MuiPaginationItem-ellipsis": {
      height: "32px",
    }
  },
  pageCount: {
    position: 'relative',
    top: '5px',
    left: '5px',
  }
 }));

function CustomPagination({paginationParams = {}}){
    const classes = useStyles();
    const page = paginationParams?.page || 1;
    const pageLimit = paginationParams?.pageLimit || 10;
    const totalCount = paginationParams?.totalCount;

    return(
        <div className={classes.paginationContainer}>
          <Pagination
            count={Math.ceil(totalCount / pageLimit)}
            page={page}
            onChange={(e, newPage) => paginationParams?.onPageChange(newPage, pageLimit)}
            color="primary"
            shape="rounded"
            className={classes.pagination}
          />
          <Typography variant="body2" className={classes.pageCount}>{pageLimit} {commonStrings.page}</Typography>
        </div>
    )
}

export default CustomPagination;